"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1497))
 * @trackcomponent
 * @donotsync Syncing adds default color (@quinlan.sokol)
 */
export const CartEmpty = createSVGIcon(
  <>
    <path
      d="M3.2594 14.7143H16.2571L17.9714 5.28571H1.85712C1.73164 5.28571 1.60769 5.31326 1.49402 5.36642C1.38036 5.41958 1.27975 5.49705 1.19931 5.59335C1.11887 5.68965 1.06055 5.80244 1.02847 5.92376C0.9964 6.04507 0.991353 6.17194 1.01369 6.29542L2.41597 14.0097C2.45173 14.2074 2.55576 14.3862 2.70991 14.515C2.86406 14.6437 3.05854 14.7143 3.2594 14.7143Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9712 5.28571L18.6912 1.68571C18.7307 1.49211 18.8359 1.3181 18.989 1.19315C19.1421 1.06819 19.3336 0.99996 19.5312 1H22.2569"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2571 14.7143L15.5371 18.3143C15.4976 18.5079 15.3924 18.6819 15.2393 18.8069C15.0863 18.9318 14.8947 19 14.6971 19H5.11426"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.11621 22.4286C5.11621 22.5411 5.13838 22.6526 5.18146 22.7566C5.22453 22.8606 5.28767 22.9551 5.36726 23.0346C5.44686 23.1142 5.54135 23.1774 5.64534 23.2205C5.74933 23.2635 5.86079 23.2857 5.97335 23.2857C6.08592 23.2857 6.19737 23.2635 6.30137 23.2205C6.40536 23.1774 6.49985 23.1142 6.57945 23.0346C6.65904 22.9551 6.72217 22.8606 6.76525 22.7566C6.80833 22.6526 6.8305 22.5411 6.8305 22.4286C6.8305 22.316 6.80833 22.2045 6.76525 22.1005C6.72217 21.9965 6.65904 21.9021 6.57945 21.8225C6.49985 21.7429 6.40536 21.6797 6.30137 21.6367C6.19737 21.5936 6.08592 21.5714 5.97335 21.5714C5.86079 21.5714 5.74933 21.5936 5.64534 21.6367C5.54135 21.6797 5.44686 21.7429 5.36726 21.8225C5.28767 21.9021 5.22453 21.9965 5.18146 22.1005C5.13838 22.2045 5.11621 22.316 5.11621 22.4286Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8301 22.4286C12.8301 22.6559 12.9204 22.8739 13.0811 23.0346C13.2419 23.1954 13.4599 23.2857 13.6872 23.2857C13.9145 23.2857 14.1326 23.1954 14.2933 23.0346C14.4541 22.8739 14.5444 22.6559 14.5444 22.4286C14.5444 22.2012 14.4541 21.9832 14.2933 21.8225C14.1326 21.6617 13.9145 21.5714 13.6872 21.5714C13.4599 21.5714 13.2419 21.6617 13.0811 21.8225C12.9204 21.9832 12.8301 22.2012 12.8301 22.4286Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CartEmpty",
  {
    viewBox: "0 0 24 24",
    titleAccess: "CartEmpty",
    fill: "none",
  }
);
